import budgetService from "api/budgetService";
import pluginService from "api/pluginService";
import { ICertificate } from "dto/ICertificate";
import { IBudgetEngagementDocument } from "dto/Budget/IBudgetEngagementDocument";

/** UTF-8 → base64 (btoa działa tylko na bajtach Latin-1). */
const utf8ToBase64 = (text: string) => {
  const bytes = new TextEncoder().encode(text);
  let binary = "";
  for (let i = 0; i < bytes.length; i += 0x8000) {
    binary += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  }
  return btoa(binary);
};

const base64ToUtf8 = (b64: string) => {
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new TextDecoder("utf-8").decode(bytes);
};

/** Komunikat błędu z odpowiedzi BE (errorCodes) albo z wyjątku. */
export const errorMessage = (e: unknown, fallback: string) =>
  (e as { response?: { data?: { errorCodes?: { message: string }[] } } })
    ?.response?.data?.errorCodes?.[0]?.message ??
  (e as Error)?.message ??
  fallback;

/**
 * Podpis XAdES elementu dokumentu wniosku o zaangażowanie — jak w Magistracie
 * (AcceptationWizard: dekret → pobranie najnowszego XML → podpis elementu „Ak-…” →
 * zapis): BE wydaje aktualny XML, wtyczka podpisuje wskazany element (podpis pod
 * korzeniem, wcześniejsze podpisy nietknięte), BE weryfikuje, że zmieniły się tylko
 * podpisy, i zapisuje nową wersję.
 */
export const signEngagementDocumentElement = async (
  engagementId: string,
  elementId: string,
  cert: ICertificate,
): Promise<IBudgetEngagementDocument> => {
  const doc = await budgetService.getEngagementDocumentApi(engagementId);
  if (!doc) throw new Error("Zaangażowanie nie ma dokumentu wniosku.");
  if (!doc.MySignableElementIds.includes(elementId))
    throw new Error("Ten element nie czeka na Twój podpis.");

  const signed = await pluginService.signDocument({
    CertificateSerialNumber: cert.SerialNumber,
    Content: utf8ToBase64(doc.Xml),
    ContentType: "text/xml",
    FileName: doc.FileName,
    GenerateReport: false,
    ForceXades: true,
    XmlElementId: elementId,
  });

  const content = (signed?.data as { Content?: string } | undefined)?.Content;
  if (!content) throw new Error("Wtyczka nie zwróciła podpisanego dokumentu.");

  return budgetService.attachEngagementDocumentSignatureApi({
    engagementId,
    ElementId: elementId,
    Xml: base64ToUtf8(content),
    Version: doc.Version,
  });
};
